import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ConstantsService} from "../../../fidelidade/ConstantsService";
import {EstoqueService} from "../../../services/estoque.service";
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";

import {KendoPopupUtils} from "../../../lib/KendoPopupUtils";
import {ModalMovimentacoesEstoqueComponent} from "../../../tela-gerenciar-estoque/modal-movimentacoes-estoque";

@Component({
  selector: 'app-associar-insumo',
  templateUrl: './associar-insumo.component.html',
  styleUrls: ['./associar-insumo.component.scss']
})
export class AssociarInsumoComponent implements OnInit, OnChanges {
  @Input() tipo = 'produto';
  @Input() objeto: any = {};
  temModuloEstoque: boolean
  insumos = [];
  fichasProducao: any[] = [];
  fichasProducaoFiltradas: any[] = [];
  carregandoInsumo;
  insumoAtual: any;
  empresa: any = {};
  producaoPedidosAtiva = false;
  public data: any[] = [];
  @ViewChild("dropdowntree", { static: false }) public dropdowntree: any;
  public expandedNodes: number[] = [];
  constructor(private constantsService: ConstantsService, private dialogService: DialogService,
              private estoqueService: EstoqueService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes.objeto) return;
    if(this.tipo === 'produto'){
      this.objeto.momentoBaixaEstoque = this.empresa?.id && !this.producaoPedidosAtiva
        ? null : this.objeto.momentoBaixaEstoque || null;
      this.objeto.fichasProducao = this.objeto.momentoBaixaEstoque === 'producao'
        ? [...(this.objeto.insumosVinculados || [])] : [];
    }
    this.insumoAtual = this.objeto.insumo;
    if(!changes.objeto.firstChange && this.temModuloEstoque){
      this.objeto.controlarEstoque = this.estoqueSalvoAtivo();
      if(this.objeto.controlarEstoque) this.carregueInsumos();
    }
  }

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe(   empresa => {
        if(empresa){
          this.empresa = empresa;
          this.producaoPedidosAtiva = this.constantsService.possuiRecurso(empresa, 'estoque') &&
            (empresa.producaoPedidosAtiva === true || Number(empresa.producaoPedidosAtiva) === 1);
          if(this.tipo === 'produto' && !this.producaoPedidosAtiva) {
            this.objeto.momentoBaixaEstoque = null;
            this.objeto.fichasProducao = [];
          }
          if(this.empresa.estoqueVinculadoProduto)
            if(!this.objeto.estoque)
              this.objeto.estoque = {}
        }
    });

    this.constantsService.moduloEstoque$.subscribe( async data => {
      this.temModuloEstoque = data

      if (this.estoqueSalvoAtivo() && this.temModuloEstoque) {
        this.objeto.controlarEstoque = true;
        this.insumoAtual = this.objeto.insumo;
        await this.carregueInsumos();
      }
    })
  }

  estoqueSalvoAtivo(){
    if(this.tipo === 'produto' && this.objeto.momentoBaixaEstoque === 'producao') return true;
    if(this.objeto.insumo && this.objeto.insumo.id) return true;
    if(this.objeto.estoque && this.objeto.estoque.id)
      return this.objeto.estoque.ativo;

    return false;
  }

  obtenhaFormatoEstoque( ) {
    const unidadeMedida = this.empresa.estoqueVinculadoProduto ? this.objeto.unidadeMedida :
      ( this.objeto.insumo ? this.objeto.insumo.unidadeMedida : null  ) ;

    if(!unidadeMedida || unidadeMedida.sigla === 'und')
      return '0';

    let sigla: string = unidadeMedida.sigla;

    if( sigla === 'g' || sigla === 'ml')
      return String(`0 ${sigla}`);

    return String(`0.00 ${sigla}`);
  }

  alterouInsumo($event: any) {

  }

  onFilterInsumo(filterValue: any) {
    if(String(filterValue || '').trim())
      this.expandedNodes = this.data.map((grupo: any) => grupo.id);
  }

  onValueChange(item: any): void {

    // Verifica se o item possui filhos (items), impedindo sua seleção
    if (item && item.disabled) {
      // Fecha e reabre o dropdown para atualizar a seleção visual
      this.dropdowntree.toggle(false); // Fecha o dropdown
      setTimeout(() => {
          this.objeto.insumo = null;
          this.dropdowntree.toggle(true)}
        , 0);

    } else {
      this.objeto.insumo = item; // Permite a seleção apenas para itens internos
    }
  }

  async carregueInsumos(){
    this.carregandoInsumo = true;
    this.insumos = await this.estoqueService.listeInsumos(0, 500, {vincular: true})

    if(this.insumos){
      this.insumos.forEach((insumo: any) => {
        insumo.vincular = true;
        insumo.descricao = `${insumo.nome} - ${insumo.grupo ? insumo.grupo.nome : 'OUTROS'}`;
      })
      this.setInumos(this.insumos);
      this.fichasProducao = this.insumos.filter((insumo: any) => insumo.fichaTecnica || insumo.objeto === 'ficha-tecnica');
      this.fichasProducaoFiltradas = this.fichasProducao.slice();
    }

    if(this.objeto.insumo){
      let atual: any = this.insumos.find((item: any) => item.id ===  this.objeto.insumo.id);
      if(atual){
        if(this.insumoAtual && Number(this.insumoAtual.id) === Number(atual.id))
          delete atual.vincular;
        this.objeto.insumo = atual
        this.updateExpandedKeys(atual)
      }
    }


    this.carregandoInsumo = false;
  }

  setInumos(insumos: any){
    this.data = [];
    insumos.forEach((insumo: any) => {
      let grupo = insumo.grupo ?  insumo.grupo : {id: -1, nome:  'OUTROS'};

      let itemGrupo = this.data.find((item: any) => item.nome === grupo.nome);

      if(!itemGrupo) {
        itemGrupo = { id: grupo.id, nome: grupo.nome.toUpperCase(), items: [],  disabled: true}
        this.data.push(itemGrupo)
      }

      itemGrupo.items.push(insumo);
    })

    this.data.sort((a: any, b: any) => a.nome.localeCompare(b.nome))

    this.data.forEach((item: any) => {
      item.items.sort((a: any, b: any) => a.nome.localeCompare(b.nome))
    })

  }

  async alterouControlarEstoque() {
    if(!this.insumos.length)
      await this.carregueInsumos();

    if(this.objeto.codigoPdv && !this.objeto.insumo)
      this.objeto.insumo = this.insumos.find((item: any) => item.codigo  === this.objeto.codigoPdv)
  }



  setInsumoDesvinculado(){
    if(this.tipo === 'produto' && this.temModuloEstoque && !this.empresa.estoqueVinculadoProduto){
      const momento = this.objeto.controlarEstoque ? (this.producaoPedidosAtiva ? (this.objeto.momentoBaixaEstoque || 'venda') : 'venda') : 'venda';
      const insumos = !this.objeto.controlarEstoque ? [] : momento === 'producao'
        ? (this.objeto.fichasProducao || []) : (this.objeto.insumo ? [this.objeto.insumo] : []);
      this.objeto.configuracaoConsumoEstoque = {momento, insumos: insumos.map((insumo: any) => ({id: insumo.id}))};
      return;
    }
    if(this.insumoAtual ){
      if( !this.objeto.controlarEstoque || !this.objeto.insumo){
        this.objeto.insumoRemover = this.insumoAtual;
        delete  this.objeto.insumo;
      }  else if(this.objeto.insumo.id !== this.insumoAtual.id ){
        this.objeto.insumoRemover = this.insumoAtual;
      }
    }
  }

  salvou(){
    if(this.objeto.configuracaoConsumoEstoque){
      this.objeto.momentoBaixaEstoque = this.objeto.configuracaoConsumoEstoque.momento === 'producao' ? 'producao' : null;
      this.objeto.insumosVinculados = !this.objeto.controlarEstoque ? [] : this.objeto.momentoBaixaEstoque === 'producao'
        ? [...this.objeto.fichasProducao] : (this.objeto.insumo ? [this.objeto.insumo] : []);
      this.objeto.insumo = this.objeto.insumosVinculados[0] || null;
      this.insumoAtual = this.objeto.insumo;
      delete this.objeto.insumoRemover;
      delete this.objeto.configuracaoConsumoEstoque;
    }
    if(this.objeto.insumo &&  this.objeto.insumo.vincular){
      delete this.objeto.insumo.vincular;
      this.insumoAtual = this.objeto.insumo
    }
  }

  abraModalMovimentacoes(produto: any) {
    //scrollable: true
    const windowRef: DialogRef = this.dialogService.open({
      content: ModalMovimentacoesEstoqueComponent,
      minWidth: 250,
      width: window.innerWidth > 900 ? 900 : window.innerWidth,
      cssClass: 'bsModal',
      maxHeight:  window.innerHeight - 100

    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)
    windowRef.content.instance.produto = produto;
    windowRef.result.subscribe( (result: any) => { },
      (a) => {      });
  }

  alterouMomentoBaixa() {
    if(this.objeto.momentoBaixaEstoque === 'producao'){
      if(!this.objeto.fichasProducao?.length && this.objeto.insumo &&
         (this.objeto.insumo.fichaTecnica || this.objeto.insumo.objeto === 'ficha-tecnica'))
        this.objeto.fichasProducao = [this.objeto.insumo];
    } else {
      // A volta à venda exige escolher explicitamente o vínculo único.
      this.objeto.insumo = this.objeto.fichasProducao?.length === 1 ? this.objeto.fichasProducao[0] : null;
    }
  }

  filtreFichasProducao(texto: string) {
    const termo = String(texto || '').toLowerCase();
    this.fichasProducaoFiltradas = this.fichasProducao.filter(ficha =>
      ficha.nome.toLowerCase().includes(termo) || String(ficha.codigo || '').toLowerCase().includes(termo));
  }

  valideConfiguracaoConsumo(): string {
    if(this.carregandoInsumo) return 'Aguarde o carregamento dos insumos e fichas.';
    if(this.tipo !== 'produto' || !this.temModuloEstoque || !this.objeto.controlarEstoque || this.empresa.estoqueVinculadoProduto)
      return null;
    if(this.objeto.momentoBaixaEstoque === 'producao' && !this.producaoPedidosAtiva)
      return 'Ative a produção de pedidos nas configurações do módulo Estoque no Superadmin.';
    if(this.objeto.momentoBaixaEstoque === 'producao')
      return this.objeto.fichasProducao?.length ? null : 'Selecione pelo menos uma ficha para a produção.';
    return this.objeto.insumo?.id ? null : 'Selecione o insumo ou a ficha para a baixa pelo pedido/venda.';
  }

  updateExpandedKeys(itemSelecionado: any) {
    // Caminho para o item selecionado
    let grupo = itemSelecionado.grupo ? itemSelecionado.grupo.id  : -1;
    // Atualiza as expandedKeys com os nós necessários
    this.expandedNodes = [grupo];
  }

  public isNodeExpanded = (node: any): boolean => {
    return this.expandedNodes.indexOf(node.id) !== -1;
  };

  public handleCollapse(args: any): void {
    this.expandedNodes = this.expandedNodes.filter(
      (id) => id !== args.dataItem.id
    );
  }

  public handleExpand(args: any): void {
    this.expandedNodes = this.expandedNodes.concat(args.dataItem.id);
  }

  public onNodeLabelClick(event: MouseEvent, dataItem: any): void {
    if(!dataItem.items || !dataItem.items.length)
      return;

    event.preventDefault();
    event.stopPropagation();
    const id = dataItem.id;
    if(this.expandedNodes.indexOf(id) !== -1)
      this.expandedNodes = this.expandedNodes.filter((nodeId: number) => nodeId !== id);
    else
      this.expandedNodes = this.expandedNodes.concat(id);
  }

}
